module.exports = __webpack_public_path__ + "static/media/1.72f3f35c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/1.svg
// module id = 387
// module chunks = 0